import React from 'react';
import PopupNg from '@/ui/PopupNg';
import { DialogBody, Docked } from '@/ui/dialogs/Dialog';
import TournamentTicketsDailyLimit from 'nike-ui/src/components/tournaments/tournament-tickets-daily-limit/TournamentTicketsDailyLimit';

const TournamentDailyLimitDialog = ({ lastTournamentDay }) => {
    const onClose = () => {
        PopupNg.dispatcher.close('Tournaments/DailyLimitDialog');
    };

    return (
        <Docked onClose={onClose}>
            <DialogBody>
                <TournamentTicketsDailyLimit onClose={onClose} lastTournamentDay={lastTournamentDay} />
            </DialogBody>
        </Docked>
    );
};

export default TournamentDailyLimitDialog;
